
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/black-friday/[categorySlug]",
      function () {
        return require("private-next-pages/black-friday/[categorySlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/black-friday/[categorySlug]"])
      });
    }
  